// /mnt/mantenimientos/frontend/src/modules/MonitorizacionModule.jsx
import React, { useState } from "react";
import { useCliente } from "../context/ClienteContext";
import PfSenseMonitorPanel from "./monitorizacion/PfSenseMonitorPanel";
import NativeMonitorPanel from "./monitorizacion/NativeMonitorPanel";
import { MODULE_IDS } from "./moduleIds";

import "../styles/modules/monitorizacion.css";

export default function MonitorizacionModule() {
  const {
    clienteSeleccionadoId,
    setActiveModule,
    effectiveAccess,
  } = useCliente();
  const [monitorView, setMonitorView] = useState("native");
  const canOpenEquipment = effectiveAccess.moduleKeys.includes(MODULE_IDS.EQUIPOS);

  // ✅ Ahora sí: return temprano, después de hooks
  if (!clienteSeleccionadoId) {
    return (
      <div className="card">
        Selecciona un cliente para ver la monitorización.
      </div>
    );
  }

  if (monitorView === "native") {
    return <div className="mon-module"><div className="mon-source-tabs mp-source-switch"><button className="button primary">Monitorización · Megaprint</button><button className="button secondary" onClick={() => setMonitorView("firewalls")}>Firewalls · Megaprint</button></div><NativeMonitorPanel clientId={clienteSeleccionadoId} onOpenEquipment={canOpenEquipment ? () => setActiveModule(MODULE_IDS.EQUIPOS) : null} /></div>;
  }

  if (monitorView === "firewalls") {
    return <div className="mon-module">
      <div className="mon-source-tabs mp-source-switch"><button className="button secondary" onClick={() => setMonitorView("native")}>Monitorización · Megaprint</button><button className="button primary">Firewalls · Megaprint</button></div>
      <PfSenseMonitorPanel clientId={clienteSeleccionadoId} />
    </div>;
  }
}
